import { SmartComponentType } from "../../enum/enumSmartComponentType";
import { SmartComponent } from "../smart-components/smart-component";
import { AddressDetails } from "../smart-components/smart-component-property";
/**
 * This class handle common property of components.
 * It's pourpose is to be extended by other component adapter and give object oriented structure to the component
 * and inner skills
 */
export abstract class ComponentAdapterParent {
  protected _name: string = "";
  protected _description: string = "";
  protected _summary: boolean = false;
  protected _listSubscribeAddress: Array<AddressDetails> = [];
  protected _idSmartComponentKind: SmartComponentType =
    SmartComponentType.UNKNOWN;
  protected _idEnvironment: number = null;

  /**
   * Get the name of the component
   */
  get Name() {
    return this._name;
  }

  /**
   * Get the summary of the component
   */
  get Summary() {
    return this._summary;
  }

  /**
   * Get the id smart component kind
   */
  get IdSmartComponentKind() {
    return this._idSmartComponentKind;
  }

  /**
   * Get the id of the environment
   */
  get IdEnvironment() {
    return this._idEnvironment;
  }

  /**
   * Get the user-friendly description of the component
   */
  get Description() {
    return this._description;
  }

  /**
   * Get the list of address to subscribe in UI component
   */
  get ListSubscribeAddress() {
    return this._listSubscribeAddress;
  }

  constructor() {}
}
